import React, { useState, useEffect, useContext } from 'react'
import label from '../../../../../../../../../assets/i18n/en.json'
import { MembershipType as MembershipType } from '../../../../../../../../common/enum/membership-type.enum';
import HPTSelect from '../../../../../../../templates/components/HPTSelect';
import PracticeLocationSelector from '../../../../../../../templates/components/PracticeLocationSelector';
import Utilities from '../../../../../../../../services/commonservice/utilities';
import ProductService from '../../../../../../../../services/api/product.service';
import { useMediaQuery } from 'react-responsive'
import { store } from '../../../../../../../../context/StateProvider';
import FormValidatorService from '../../../../../../../../services/validator/form-validator.service';
import toast from "react-hot-toast";
import { isEmpty, isNull } from 'lodash';
const MembershipForm = (props) => {
    // Pull properties form parent
    const { isEdit, submitHandler, isLoader, isWizard } = props;
    // Set states for form
    //const [isLoader, setIsLoader] = useState(false)
    const stateAndDispatch = useContext(store)
    const state = stateAndDispatch.state
    const [formData, setFormData] = useState(props.initialData || {})
    const [locationId, setLocationId] = useState(props?.isEdit ? props.initialData?.practiceLocationId : state.practiceLocationId);
    const [errors, setErrors] = useState({})
    const [productList, setProductList] = useState([])
    const [serviceList, setServiceList] = useState([])
    const [membershipItemsNeverExpire, setMembershipItemsNeverExpire] = formData.membershipItemsNeverExpire ? useState(Boolean(formData.membershipItemsNeverExpire)) : useState(false)
    // const [subTotal, setSubTotal] = useState(0)
    // const [totalDiscount, setTotalDiscount] = useState(0)
    // const [total, setTotal] = useState(0)
    // const [isTotalError, setIsTotalError] = useState(true)
    const isMobile = useMediaQuery({ query: `(max-width: 576px)` });
    const required = ['name',
        'membershipType',
        'membershipPeriodQty',
        'unitPrice',
        'membershipPeriodUnit',
        'membershipOfferBeginsOn'
    ]

    const MembershipPeriodUnitList = [
        {
            label: 'Month(s)',
            value: 'Month'
        },
        {
            label: 'Quarter(s)',
            value: 'Quarter'
        },
        {
            label: 'Year(s)',
            value: 'Year'
        }
    ]
    const ItemType = [
        {
            label: 'Service',
            value: 'Service'
        },
        {
            label: 'Product',
            value: 'Product'
        }
    ]
    const [selectedPeriodUnit, setSelectedPeriodUnit] = useState(formData.membershipPeriodUnit ? MembershipPeriodUnitList.find(obj => obj.value === formData.membershipPeriodUnit) : null);
    const [itemsList, setItemsList] = useState(props?.itemsList || []);

    const serviceLookup = () => {
        const reqObj = {
            PracticeLocationId: locationId,
            isActive: 1
        };
        ProductService.serviceLookup(reqObj)
            .then(res => {
                setServiceList(res.data);
            }
            ).catch(error => {
                console.log(error)
            })
    }
    const productLookup = () => {
        const reqObj = {
            practiceLocationId: locationId,
            includePracticeItems: 'yes',
            isActive: true,
            itemType: 1
        };
        ProductService.productLookup(reqObj)
            .then(res => {
                if (res) {
                    setProductList(res)
                }
            }
            )
    }
    // formula for input change
    const inputChange = (e) => {
        const { name, value, type, checked } = e.target;
        let newStateObject = { ...formData };

        if (name === "unitPrice") {
            newStateObject[name] = value ? parseFloat(value) : 0;
            return setFormData(newStateObject);
        }

        if (type === "number") {
            newStateObject[name] = value ? parseFloat(value) : null;
            return setFormData(newStateObject);
        }

        if (name === "membershipItemsNeverExpire") {
            newStateObject[name] = checked ? 1 : 0;
            if ([3].includes(formData.membershipType)) {
                // Clear RolloverTimeLimit in form
                newStateObject["rollOverTimeLimit"] = undefined;
            }
            if ([1, 2].includes(formData.membershipType)) {
                // Clear RolloverTimeLimit in itemList
                itemsList.forEach((_, index) => {
                    changeItemList({ target: { name: "rollOverTimeLimit", value: undefined } }, index);
                });
            }
            setFormData(newStateObject);
            setMembershipItemsNeverExpire(checked);
            return;
        }

        newStateObject[name] = value;
        return setFormData(newStateObject);
    };

    const onLocationChanged = (newLocationId) => {
        setLocationId(newLocationId)
    }


    useEffect(() => {
        if (props.isEdit) {
            if (props.initialData?.membershipItems?.length > 0) {
                let localItemList = []
                props.initialData?.membershipItems.forEach((item, i) => {
                    let newItem = {
                        sequenceId: `item-${i}`,
                        "sequence": i,
                        membershipItemId: item.membershipItemId,
                        parentItemId: item.parentItemId,
                        providerId: item.providerId,
                        itemId: item.itemId,
                        name: item.name,
                        discount: item.discount,
                        discountType: item.discountType,
                        discountOverride: item.discount == null ? false : true,
                        unitPrice: item.unitPrice ? +item.unitPrice : item.unitPrice,
                        priceOverride: item.unitPrice == null ? false : true,
                        cashValue: item.cashValue,
                    }
                    if (item.itemType === 1) {
                        newItem.type = "Product"
                    } else {
                        newItem.type = "Service"
                    }
                    if ([1, 2].includes(formData.membershipType)) {
                        newItem.perPeriodQtyLimit = item.perPeriodQtyLimit
                        newItem.rollOverQtyLimit = item.rollOverQtyLimit
                        newItem.rollOverTimeLimit = item.rollOverTimeLimit
                    }
                    if ([3].includes(formData.membershipType)) {
                        newItem.countsAs = item.countsAs
                    }
                    localItemList.push(newItem)
                })
                setItemsList(localItemList)
            }
        }
    }, [])
    useEffect(() => {
        if (locationId) {
            serviceLookup()
            productLookup()
            inputChange({
                target: {
                    name: 'practiceLocationId', value: locationId
                }
            })
        }
    }, [locationId])

    useEffect(() => {
        props?.onItemsChange(itemsList);
    }, [itemsList]);

    const removeItems = (removeItem) => {
        setItemsList((current) =>
            current.filter((item) => item.sequenceId !== removeItem.sequenceId)
        );
    }
    const addItemToList = () => {
        let localItem = {
            sequenceId: `item-${itemsList.length}`,
            "sequence": itemsList.length,
            "itemId": null,
            "name": null,
            "unitPrice": null,
            "discount": null,
            "discountType": null,
            "priceOverride": null,
            "discountOverride": null,
            "cashValue": null
        }
        if ([1, 2].includes(formData.membershipType)) {
            localItem.perPeriodQtyLimit = null
            localItem.rollOverQtyLimit = null
            localItem.rollOverTimeLimit = null
        }
        if ([3].includes(formData.membershipType)) {
            localItem.countsAs = null
        }
        if (props.isEdit) {
            localItem.parentItemId = props.membershipId
        }
        setItemsList(prevItemList => [...prevItemList, localItem])
    };

    const addItem = (item, i) => {
        let newList = [...itemsList]
        newList[i].itemId = item.id
        newList[i].name = item.name
        newList[i].discount = item.discount || 0
        newList[i].discountType = parseInt(item.discountType) || 2
        newList[i].unitPrice = +item.unitPrice
        newList[i].priceOverride = true
        newList[i].discountOverride = true
        newList[i].cashValue = null
        if ([1, 2].includes(formData.membershipType)) {
            newList[i].perPeriodQtyLimit = 0; // parseInt(item.perPeriodQtyLimit) || 1
            newList[i].rollOverQtyLimit = 0; // parseInt(item.rollOverQtyLimit) || 0
            newList[i].rollOverTimeLimit = 0; // parseInt(item.rollOverTimeLimit) || 0
        }
        if ([3].includes(formData.membershipType)) {
            newList[i].countsAs = 0;
        }
        setItemsList([...newList])
    }
    const changeItemList = (e, i) => {
        let newList = [...itemsList]
        if (e.target.name === "discountType" || e.target.type === "number") {
            if (e.target.name === "perPeriodQtyLimit" && isEmpty(e.target.value)) {
                newList[i]["rollOverQtyLimit"] = 0
            }
            if (e.target.name === "countsAs" && isEmpty(e.target.value)) {
                newList[i]["countsAs"] = null
            }
            newList[i][e.target.name] = e.target.value ? parseFloat(e.target.value) : null
            return setItemsList([...newList])
        }
        else if (e.target.name === "priceOverride") {
            newList[i]["priceOverride"] = e.target.checked
            if (!e.target.checked) {
                newList[i]["unitPrice"] = null
            }
            return setItemsList([...newList])
        }
        else if (e.target.name === "discountOverride") {
            newList[i]["discountOverride"] = e.target.checked
            if (!e.target.checked) {
                newList[i]["discount"] = null
            }
            return setItemsList([...newList])
        }
        else {
            newList[i][e.target.name] = e.target.value
            return setItemsList([...newList])
        }
    }

    const toggleExpandRow = (index) => {
    setItemsList(prev =>
        prev.map((item, i) =>
        i === index ? { ...item, isExpanded: !item.isExpanded } : { ...item, isExpanded: false }
        )
    );
    };

    return (
        <>
            {props.isLoader && <div className="ui">
                <div className="ui active dimmer">
                    <div className="ui indeterminate text loader">{label.common.processing}</div>
                </div>
            </div>}
            <div className=" fields p-3">

                {!isWizard && <>
                <div className="row">

                    <div className="col-md-3 col-12 field">
                        <div className="d-flex justify-content-between align-items-start mb-0">
                            <label htmlFor="name" className="mb-0 mt-2">
                                Name <span style={{ color: 'red' }}>*</span>
                            </label>

                            <div className="form-check form-check-inline d-flex align-items-center mt-0">
                                <input
                                    type="checkbox"
                                    className="form-check-input"
                                    id="membershipItemsNeverExpire"
                                    checked={membershipItemsNeverExpire}
                                    name="membershipItemsNeverExpire"
                                    onChange={e => { inputChange(e) }}
                                />
                                <label
                                    className="form-check-label ms-2"
                                    htmlFor="membershipItemsNeverExpire"
                                    style={{ whiteSpace: 'nowrap' }}
                                >
                                    Never Expire
                                </label>
                            </div>
                        </div>

                        <input
                            placeholder="Name"
                            type="text"
                            name="name"
                            value={formData.name}
                            onChange={(e) => {
                                e.preventDefault();
                                inputChange(e);
                            }}
                            required
                            className="form-control"
                        />
                    </div>
                    <div className="required field col-md-3 col-3">
                        <label>Location</label>
                        <PracticeLocationSelector locationId={props.isEdit ? props?.initialData?.practiceLocationId : null} disabled={props.isEdit} dontResetState={true} onSelected={onLocationChanged} />
                    </div>

                    <div className="required field col-md-3 col-3">
                        <label>Type</label>
                        <HPTSelect
                            className="react-select-container"
                            classNamePrefix="react-select"
                            name="membershipType"
                            value={MembershipType.find(obj => obj.value === formData.membershipType)}
                            options={MembershipType}
                            onChange={e => {
                                //e.preventDefault();
                                setItemsList([])
                                inputChange({ target: { value: e.value, name: 'membershipType' } })
                            }}
                            getOptionLabel={(option) => { return (option.title) }}
                        />
                    </div>
                    <div className="required field col-lg-3 col-3">
                        <label>Price</label>
                        <input
                            placeholder="Price"
                            type="number"
                            name="unitPrice"
                            value={formData.unitPrice}
                            onChange={(e) => {
                                e.preventDefault();
                                inputChange(e);
                            }}
                        />
                    </div>

                </div>

                <div className="row">

                    <div className="required field col-lg-3 col-3">
                        <label>Duration</label>
                        <input
                            placeholder="Duration"
                            type="number"
                            name="membershipPeriodQty"
                            value={formData.membershipPeriodQty}
                            onChange={(e) => {
                                e.preventDefault();
                                inputChange(e);
                            }}
                        />
                    </div>
                    <div className="field required col-lg-3 col-3">
                        <label>Period</label>
                        <HPTSelect
                            className="react-select-container"
                            classNamePrefix="react-select"
                            name="membershipPeriodUnit"
                            value={selectedPeriodUnit}
                            options={MembershipPeriodUnitList}
                            onChange={e => {
                                setSelectedPeriodUnit(e);
                                inputChange({ target: { value: e.value, name: 'membershipPeriodUnit' } })
                            }}
                            getOptionLabel={(option) => { return (option.label) }}
                        />
                    </div>

                    <div className="field required col-lg-3 col-3">
                        <label>Start Date</label>
                        <input type="date"
                            className="form-control"
                            value={formData.membershipOfferBeginsOn ? Utilities.toDate(formData.membershipOfferBeginsOn) : null}
                            onChange={e => {
                                e.preventDefault();
                                inputChange(e);
                            }}
                            name="membershipOfferBeginsOn"
                        />
                    </div>
                    <div className="field col-lg-3 col-3">
                        <label>End Date</label>
                        <input type="date"
                            className="form-control"
                            disabled={formData.membershipOfferBeginsOn ? false : true}
                            min={formData.membershipOfferBeginsOn}
                            value={formData.membershipOfferEndsOn ? Utilities.toDate(formData.membershipOfferEndsOn) : ""}
                            onChange={e => {
                                e.preventDefault();
                                inputChange(e);
                            }}
                            name="membershipOfferEndsOn"
                        />
                    </div>

                </div>

                <div className="row">

                    {[3].includes(formData.membershipType) ? <>
                        <div className="required field col-lg-3 col-3">
                            <label>Quantity/Period</label>
                            <input value={formData.perPeriodQtyLimit} type="number" min={1} name="perPeriodQtyLimit"
                                onChange={e => {
                                    e.preventDefault();
                                    inputChange(e)
                                }} ></input>
                        </div>
                        <div className="field col-lg-3 col-3">
                            <label>Rollover Quantity</label>
                            <input disabled={formData.perPeriodQtyLimit ? false : true} value={formData.rollOverQtyLimit} type="number" name="rollOverQtyLimit" onChange={e => {
                                e.preventDefault();
                                if (e.target.value <= formData.perPeriodQtyLimit) {
                                    inputChange(e)
                                } else {
                                    inputChange({ target: { value: "", name: 'rollOverQtyLimit' } })

                                }
                            }} /> </div>
                        {!membershipItemsNeverExpire && (
                            <div className="field col-lg-3 col-3">
                                <label>Rollover Time Limit</label>
                                <input
                                    type="number"
                                    name="rollOverTimeLimit"
                                    value={formData.rollOverTimeLimit}
                                    disabled={!formData.membershipPeriodQty}
                                    onChange={(e) => {
                                        e.preventDefault();
                                        if (e.target.value <= formData.membershipPeriodQty) {
                                            inputChange(e);
                                        } else {
                                            inputChange({
                                                target: {
                                                    value: "",
                                                    name: "rollOverTimeLimit"
                                                }
                                            });
                                        }
                                    }}
                                />
                            </div>
                        )}

                    </> : null}
                </div>

                </>
                }

                {/* <div className="row">
                    <div className="field col-12">
                        <label>Instructions</label>
                        <textarea placeholder="Instructions"
                            className="form-control"
                            value={formData.membershipInstructions}
                            onChange={e => { e.preventDefault(); inputChange(e) }}
                            name="membershipInstructions"
                            rows={2}
                        ></textarea>
                    </div>
                </div> */}

                <div className="row">

                    {formData.membershipType &&
                        <div className="field col-12" style={{ marginTop: 15 }}>
                            <span>Products/Services </span>
                            <button disabled={props.disabled} className="btn btn-primary" onClick={e => { e.preventDefault(); addItemToList(); }}>
                                <i className="icon plus"></i>
                            </button>
                        </div>
                    }

                    {itemsList && itemsList.length > 0 &&
                        <div className="row d-flex">
                            <div className='container-fluid mt-3'>
                                <div className='row d-flex'>
                                    <div className='col-12 px-0 card' style={{ overflow: 'unset!important', border: 'none' }}>


<div className="membership-item-list">
  {itemsList && itemsList.map((item, i) => (
    <div key={i} className="membership-item-entry border p-3 mb-3 rounded bg-light">

    <div className="col-12" style={{paddingTop:'30px'}}>
        <h5 >Select the product or service that can be redeemed:</h5>
    </div>

      <div className="row">
        <div className="col-md-4">
          <label>Type</label>
          <HPTSelect
            options={ItemType}
            name="type"
            value={ItemType.find(obj => obj.value === item.type)}
            onChange={e => changeItemList({ target: { value: e.value, name: 'type' } }, i)}
            className="react-select-container"
            classNamePrefix="react-select"
          />
        </div>

        <div className="col-md-4">
          <label>Service/Product Name</label>
          {item.type === "Product" ? (
            <HPTSelect
              options={productList}
              isLoading={!productList}
              onChange={e => addItem(e, i)}
              value={productList.find(obj => obj.id === item.itemId)}
              className="react-select-container"
              classNamePrefix="react-select"
              placeholder="Select Item"
              getOptionLabel={option => option.name + (option.manufacturerName ? (' | ' + option.manufacturerName) : '') + (option.tags?.length > 0 ? (' | ' + option.tags.map(t => t.name).join(', ')) : '')}
              getOptionValue={option => option.id}
              isDisabled={!item.type}
            />
          ) : item.type === "Service" ? (
            <HPTSelect
              options={serviceList}
              isLoading={!serviceList}
              onChange={e => addItem(e, i)}
              value={serviceList.find(obj => obj.id === item.itemId)}
              className="react-select-container"
              classNamePrefix="react-select"
              placeholder="Select Item"
              getOptionLabel={option => option.name}
              getOptionValue={option => option.id}
              isDisabled={!item.type}
            />
          ) : <select className='form-select' disabled value={null} />}
        </div>

        <div className="col-md-4 text-end">
          <label>&nbsp;</label>
          <button
            className="btn btn-outline-danger w-100"
            onClick={e => { e.preventDefault(); removeItems(item) }}
          >
            <i className='icon trash'></i> Remove
          </button>
        </div>


      </div>

      <div className="row">

    <div className="col-12" style={{paddingTop:'30px'}}>
        <h5 >Pricing & Redemption — Specify any extra charge when redeeming, and the cash value that can be applied to something else if not redeemed.</h5>
    </div>

        <div className="col-md-4">
          <label>Additional Charge When Redeemed</label>
          <input
            type="number"
            name="unitPrice"
            value={item.unitPrice}
            disabled={!(item.type && item.priceOverride)}
            onChange={e => changeItemList(e, i)}
            className="form-control"
          />
            <div className="col-md-12 form-check">
                <input
                    className="form-check-input"
                    type="checkbox"
                    name="priceOverride"
                    checked={item.priceOverride}
                    onClick={e => changeItemList(e, i)}
                />
                <label className="form-check-label">Uncheck to use original price</label>
            </div>

        </div>

        {/* <div className="col-md-4">
          <label>Discount</label>
          <div className="input-group">
            <input
              type="number"
              name="discount"
              value={item.discount}
              onChange={e => changeItemList(e, i)}
              disabled={!(item.type && item.discountOverride)}
              className="form-control"
            />
            <select
              name="discountType"
              value={item.discountType}
              onChange={e => changeItemList(e, i)}
              className="form-select"
              disabled={!(item.type && item.discountOverride)}
            >
              <option value={2}>%</option>
              <option value={1}>$</option>
            </select>
          </div>
          <div className="form-check">
            <input
              className="form-check-input"
              type="checkbox"
              name="discountOverride"
              checked={item.discountOverride}
              onClick={e => changeItemList(e, i)}
            />
            <label className="form-check-label">Override</label>
          </div>
        </div> */}




        <div className="col-md-4">
          <label>Cash Value (can be applied to something else)</label>
          <input
            type="number"
            name="cashValue"
            value={item.cashValue}
            disabled={!item.type}
            onChange={e => changeItemList(e, i)}
            className="form-control"
          />
        </div>


      </div>

      {[1, 2].includes(formData.membershipType) && (
        <div className="row">
    <div className="col-12" style={{paddingTop:'30px'}}>

        <h5>
        {(() => {
            const { membershipType, membershipItemsNeverExpire, membershipPeriodUnit, membershipPeriodQty } = formData;

            if (membershipType === 1 && membershipItemsNeverExpire) {
            return `Credits — How many credits are granted at the beginning of the membership? How many can roll over after ${membershipPeriodQty} ${membershipPeriodUnit}(s)?`;
            }

            if (membershipType === 1 && !membershipItemsNeverExpire) {
            return `Credits — How many credits are granted at the beginning of the membership? How many can roll over after ${membershipPeriodQty} ${membershipPeriodUnit}(s) and when would they expire?`;
            }

            if (membershipType === 2 && membershipItemsNeverExpire) {
            return `Credits — How many credits are granted each ${membershipPeriodUnit}? How many can roll over each ${membershipPeriodUnit}?`;
            }

            if (membershipType === 2 && !membershipItemsNeverExpire) {
            return `Credits — How many credits are granted each ${membershipPeriodUnit}? How many can roll over each ${membershipPeriodUnit} and when would they expire?`;
            }

            return 'Credits — Details not available';
        })()}
        </h5>


    </div>            
          <div className="col-md-4">
            <label>Quantity/{formData.membershipPeriodUnit}</label>
            <input
              type="number"
              name="perPeriodQtyLimit"
              value={item.perPeriodQtyLimit}
              disabled={!item.type}
              onChange={e => changeItemList(e, i)}
              className="form-control"
            />
          </div>
          <div className="col-md-4">
            <label>Rollover Quantity</label>
            <input
              type="number"
              name="rollOverQtyLimit"
              value={item.rollOverQtyLimit}
              disabled={!(item.type && item.perPeriodQtyLimit)}
              onChange={e => {
                e.preventDefault();
                if (e.target.value <= item.perPeriodQtyLimit) {
                  changeItemList(e, i);
                } else {
                  changeItemList({ target: { value: '', name: 'rollOverQtyLimit' } }, i);
                }
              }}
              className="form-control"
            />
          </div>

          {!membershipItemsNeverExpire && (
            <div className="col-md-4">
              <label>Rollover Time Limit ({formData.membershipPeriodUnit}(s))</label>
              <input
                type="number"
                name="rollOverTimeLimit"
                value={item.rollOverTimeLimit}
                disabled={!(item.type && formData.membershipPeriodQty)}
                onChange={e => {
                  e.preventDefault();
                  if (e.target.value <= formData.membershipPeriodQty) {
                    changeItemList(e, i);
                  } else {
                    changeItemList({ target: { value: '', name: 'rollOverTimeLimit' } }, i);
                  }
                }}
                className="form-control"
              />
            </div>
          )}






        </div>
      )}




      {[3].includes(formData.membershipType) && (
        <div className="row">

    <div className="col-12" style={{paddingTop:'30px'}}>
        <h5 >Count As — If this product or service counts as multiple credits when redeemed, specify that amount here.  Otherwise leave blank if it counts as a single credit.</h5>
    </div>


          <div className="col-md-4">
            <label>Count As</label>
            <input
              type="number"
              name="countsAs"
              value={item.countsAs}
              disabled={!(item.type && formData.perPeriodQtyLimit)}
              onChange={e => {
                e.preventDefault();
                if (e.target.value <= formData.perPeriodQtyLimit) {
                  changeItemList(e, i);
                } else {
                  changeItemList({ target: { value: '', name: 'countsAs' } }, i);
                }
              }}
              className="form-control"
            />
          </div>
        </div>
      )}





    </div>
  ))}
</div>



                                    </div >
                                </div >
                            </div >

                        </div >}

                    {!isWizard &&  <>   
                    <div className="mt-3 d-flex justify-content-between modal-button-bar">
                        <div className='col-auto'>
                            <button className="btn btn-primary" onClick={e => {
                                e.preventDefault();
                                if (!FormValidatorService.checkForm(errors, formData, required)) {
                                    toast.error("Please make sure the form is complete")
                                }
                                else if (itemsList.length <= 0) {
                                    toast.error("Please add at least one item")
                                }
                                else if (
                                    formData.membershipType == 3 &&
                                    !formData.membershipItemsNeverExpire &&
                                    (formData?.rollOverQtyLimit || 0) > 0 &&
                                    (formData?.rollOverTimeLimit || 0) <= 0
                                ) {
                                    toast.error("When providing a Rollover Quantity, a Rollover Time Limit must be provided.")
                                }

                                else {
                                    submitHandler(formData, itemsList)
                                }
                            }}>{isEdit ? 'Update' : 'Save'}</button>
                            {props.additionalButton}
                        </div >
                        <div className='col-auto'>
                            {props.onClose && <button className="btn btn-secondary float-right" onClick={e => { e.preventDefault(); props.onClose() }}>Close</button>}
                        </div>
                    </div >
                    </>}

                </div>
            </div >
        </>
    )
}

export default MembershipForm